import Nullstack from 'nullstack';
export default function IconBlur({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-blur",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 21a9.01 9.01 0 0 0 2.32 -.302a9.004 9.004 0 0 0 1.74 -16.733a9 9 0 1 0 -4.06 17.035z"
  }), "   ", Nullstack.element("path", {
    d: "M12 3v17"
  }), "   ", Nullstack.element("path", {
    d: "M12 12h9"
  }), "   ", Nullstack.element("path", {
    d: "M12 9h8"
  }), "   ", Nullstack.element("path", {
    d: "M12 6h6"
  }), "   ", Nullstack.element("path", {
    d: "M12 18h6"
  }), "   ", Nullstack.element("path", {
    d: "M12 15h8"
  }), " ");
}